/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ पृष्ठ',
  jump_to: 'इस पर चलें',
  jump_to_confirm: 'पुष्टि करें',
  page: '',

  // Pagination.jsx
  prev_page: 'पिछला पृष्ठ',
  next_page: 'अगला पृष्ठ',
  prev_5: 'पिछले 5 पृष्ठ',
  next_5: 'अगले 5 पृष्ठ',
  prev_3: 'पिछले 3 पृष्ठ',
  next_3: 'अगले 3 पेज'
};
